import { useState, useEffect, useCallback } from 'react';
import { getProducts } from '../services/api';

export function useProducts({ category, featured, search } = {}) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    setError('');
    
    try {
      const params = {};
      if (category) params.category = category;
      if (featured) params.featured = 'true';
      if (search && search.trim()) params.search = search.trim(); // ✅ Trim search query

      const res = await getProducts(params);
      
      let data = [];
      if (Array.isArray(res.data)) {
        data = res.data;
      } else if (res.data && Array.isArray(res.data.results)) {
        data = res.data.results;
      } else if (res.data && typeof res.data === 'object') {
        data = [res.data];
      } else {
        data = [];
      }
      
      setProducts(data);
    } catch (e) {
      console.error('Fetch error:', e);
      setError(e?.response?.data?.detail || e?.message || 'Failed to load products');
    } finally {
      setLoading(false);
    }
  }, [category, featured, search]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, loading, error, refetch: fetchProducts };
}